/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from 'react-redux';
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_helpers";
import { Link } from 'react-router-dom';
import Button from '../../../../../app/components/Button';

const QuickActions = (props) => {
  const { auth } = props;

  return (
    <>
      <div id="kt_quick_actions" className="offcanvas offcanvas-left p-10">

        <div className="offcanvas-header d-flex align-items-center justify-content-between pb-10">
          <h3 className="fw-700 m-0">
            Project Management
          </h3>
          <a
            href="#"
            className="btn btn-xs btn-icon btn-light btn-hover-danger"
            id="kt_quick_actions_close"
          >
            <i className="ki ki-close icon-xs text-muted"></i>
          </a>
        </div>

        <div className="offcanvas-content pr-5 mr-n5">
          <div className="row gutter-b">
            <div className="col-6">
              <Button
                text="New Proposal"
                to="/services/proposals/add-proposal"
                className="light-green--bg ml-0 mr-0"
              />
            </div>

            <div className="col-6">
              <Button
                text="New Client"
                to="/management/add-client"
                className="warning--bg ml-0 mr-0"
              />
            </div>
          </div>

          <div className="row gutter-b">
            {/* ACTIVE JOBS */}
            <div className="col-6 quick-action-item">
              <Link
                to='/services/jobs'
                className="btn btn-block btn-light btn-hover-success text-dark-50 text-center "
              >
                <span className="svg-icon svg-icon-3x svg-icon-success m-0">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Shopping/Box2.svg"
                    )}
                  />
                </span>
                <span className="d-block font-weight-bold mt-2 item-title">
                  Active Jobs
                </span>
              </Link>
            </div>

            {/* PROPOSALS */}
            {(auth.isAdmin || auth.isProjectManager) &&
              <div className="col-6 quick-action-item">
                <Link
                  to='/services/proposals'
                  className="btn btn-block btn-light btn-hover-warning text-dark-50 text-center "
                >
                  <span className="svg-icon svg-icon-3x svg-icon-warning m-0">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Mail-attachment.svg"
                      )}
                    />
                  </span>
                  <span className="d-block font-weight-bold mt-2 item-title">
                    View Proposals
                  </span>
                </Link>
              </div>
            }

          </div>

          <div className="row gutter-b">

            {/* PROJECT LOGS */}
            {(auth.isAdmin || auth.isProjectManager) &&
              <div className="col-4 quick-action-item">
                <Link
                  to='/project-logs'
                  className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center "
                >
                  <span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Home/Commode2.svg"
                      )}
                    />
                  </span>
                  <span className="d-block font-weight-bold mt-2 item-title">
                    Project Logs
                  </span>
                </Link>
              </div>}

            {/* COMPANY CALENDAR */}
            {(auth.isAdmin || auth.isProjectManager || auth.isTechnician) &&
              <div className="col-4 quick-action-item">
                <Link
                  to='/company-data/company-calendar'
                  className="btn btn-block btn-light btn-hover-danger text-dark-50 text-center "
                >
                  <span className="svg-icon svg-icon-3x svg-icon-danger m-0">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Layout/Layout-grid.svg")}
                    />
                  </span>
                  <span className="d-block font-weight-bold mt-2 item-title">
                    Company Calendar
                  </span>
                </Link>
              </div>
            }

            {/* MANAGE FORMS */}
            {
              (auth.isAdmin || auth.isProjectManager) &&
              <div className="col-4 quick-action-item">
                <Link
                  to='/forms'
                  className="btn btn-block btn-light btn-hover-info text-dark-50 text-center "
                >
                  <span className="svg-icon svg-icon-3x svg-icon-info m-0">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Files/File.svg"
                      )}
                    />
                  </span>
                  <span className="d-block font-weight-bold mt-2 item-title">
                    Manage Forms
                  </span>
                </Link>
              </div>
            }
          </div>

          <div className="row gutter-b">
              {/* PROJECT LOGS */}
              {(auth.isAdmin) &&
              <div className="col-4 quick-action-item">
                <Link
                  to='/services/completed-jobs'
                  className="btn btn-block btn-light btn-hover-warning text-dark-50 text-center "
                >
                  <span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Files/Compilation.svg"
                      )}
                    />
                  </span>
                  <span className="d-block font-weight-bold mt-2 item-title">
                    Completed Jobs
                  </span>
                </Link>
              </div>}
          </div>

          <div className="row gutter-b">

            {/* <div className="col-6">
              <Link
                to='/forms'
                className="btn btn-block btn-light btn-hover-info text-dark-50 text-center "
              >
                <span className="svg-icon svg-icon-3x svg-icon-info m-0">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Files/File.svg"
                    )}
                  />
                </span>
                <span className="d-block font-weight-bold  mt-2">
                  View Forms
                </span>
              </Link>
            </div> */}

            {/* <div className="col-6">
              <a
                href="#"
                className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center "
              >
                <span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Shopping/Chart-bar1.svg"
                    )}
                  />
                </span>
                <span className="d-block font-weight-bold  mt-2">
                  Tasks
                </span>
              </a>
            </div>

            <div className="col-6">
              <a
                href="#"
                className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center "
              >
                <span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Design/Color-profile.svg"
                    )}
                  />
                </span>
                <span className="d-block font-weight-bold  mt-2">
                  Settings
                </span>
              </a>
            </div> */}

          </div>
          {/* <div className="row">
            <div className="col-6">
              <a
                href="#"
                className="btn btn-block btn-light btn-hover-primary text-dark-50 text-center "
              >
                <span className="svg-icon svg-icon-3x svg-icon-primary m-0">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Euro.svg")}
                  />
                </span>
                <span className="d-block font-weight-bold  mt-2">
                  Orders
                </span>
              </a>
            </div>
          </div> */}
        </div >

      </div >

    </>
  );
}

const mapStateToProps = (state) => ({
  userProfileState: state.userProfile,
  auth: state.auth
});


export default connect(mapStateToProps, null)(QuickActions);